import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Users, ChevronRight } from "lucide-react";

const FALLBACK = [
  { id: "f1", name: "Van Ejecutiva Premium", capacity: 10, description: "Van cómoda con aire acondicionado, USB en cada asiento y bodega amplia. Ideal para grupos pequeños y ejecutivos.", features: ["Wi-Fi 4G", "Bodega XL", "Asientos reclinables"] },
  { id: "f2", name: "Buseta Turística", capacity: 19, description: "Buseta cómoda con vidrios panorámicos, perfecta para tours a Villa de Leyva, Guatavita o Melgar.", features: ["Panorámica", "Audio guía", "AC dual"] },
  { id: "f3", name: "Bus 40 pasajeros", capacity: 40, description: "Bus para grupos grandes, viajes escolares, empresariales y turismo receptivo.", features: ["Baño a bordo", "TV / Sonido", "Cinturones 3 pts"] },
];

export default function Fleet() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/fleet").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([])); }, []);
  const list = Array.isArray(items) && items.length ? items : FALLBACK;

  return (
    <section id="flota" data-testid="fleet-section" className="py-24 md:py-32 border-t border-[#3A3229]/50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div className="max-w-xl">
            <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Flota</div>
            <h2 className="font-display text-4xl md:text-5xl leading-tight text-[#F5EFE0]">
              Vehículos <span className="italic text-gold-grad">verificados,</span> conductores certificados
            </h2>
          </div>
          <Link to="/cotizar" className="text-sm text-[#E8C87A] flex items-center gap-1 hover:gap-2" style={{ transitionProperty: "gap", transitionDuration: "200ms" }}>
            Elegir mi vehículo <ChevronRight size={16} />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((v, i) => (
            <div key={v.id} data-testid={`fleet-card-${i}`} className="card-lux overflow-hidden group">
              <div className="aspect-[16/10] bg-[#171412] relative overflow-hidden">
                {v.photo_path ? (
                  <img src={fileUrl(v.photo_path)} alt={v.name}
                       className="w-full h-full object-cover group-hover:scale-105"
                       style={{ transitionProperty: "transform", transitionDuration: "600ms" }} />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#2A2520] to-[#0A0908]">
                    <svg viewBox="0 0 200 100" className="w-3/4 opacity-70">
                      <rect x="12" y="30" width="176" height="45" rx="8" fill="#D4AF37" opacity="0.15" stroke="#D4AF37" strokeWidth="1.2" />
                      <rect x="24" y="38" width="80" height="18" rx="4" fill="#0A0908" opacity="0.5" />
                      <rect x="108" y="38" width="60" height="18" rx="4" fill="#0A0908" opacity="0.5" />
                      <circle cx="45" cy="80" r="10" fill="#0A0908" stroke="#D4AF37" strokeWidth="1.2" />
                      <circle cx="155" cy="80" r="10" fill="#0A0908" stroke="#D4AF37" strokeWidth="1.2" />
                    </svg>
                  </div>
                )}
                <div className="absolute top-3 right-3 bg-[#0A0908]/85 backdrop-blur border border-[#D4AF37]/40 rounded-full px-3 py-1 text-xs text-[#E8C87A] flex items-center gap-1.5">
                  <Users size={12} /> {v.capacity} pasajeros
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-display text-2xl text-[#F5EFE0] mb-2">{v.name}</h3>
                <p className="text-sm text-[#F5EFE0]/60 mb-4 leading-relaxed line-clamp-3">{v.description}</p>
                <div className="flex flex-wrap gap-1.5">
                  {(v.features || []).slice(0,4).map((f, k) => (
                    <span key={k} className="text-[11px] px-2.5 py-1 rounded-full border border-[#D4AF37]/30 text-[#F5EFE0]/70">{f}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
